import { api } from '../api'
import { ServicePdf } from '../pdf-generators'
import { ServiceMediaUploads } from '../media-uploads'
import { base64ToFileStream } from '@/utils/files'
import { toDate } from '@/utils/filters'
import { toStyleString } from '@/utils/pdf-helpers'

const createPdfLink = ({ href, text }) => {
  return `<p style="text-align: center"><a href="${href}" style="${toStyleString({
    display: 'inline-block',
    padding: '8px 16px',
    color: 'white',
    backgroundColor: '#2698d4',
    borderRadius: '8px',
    minWidth: '160px'
  })}">${text}</a></p>`
}

const API = 'EmailMessages'

const API_EMAIL_MESSAGES = {
  SEND_EMAIL: `${API}/SendEmail`
}

class ModuleService {
  async _sendEmail ({ fromDisplayName, toEmails, replyToEmail, subject, html, tag, attachmentURL, sendViaDefault, sendBulk }) {
    try {
      const result = await api.post(API_EMAIL_MESSAGES.SEND_EMAIL, {
        fromDisplayName,
        toEmails,
        replyToEmail,
        subject,
        html,
        tag,
        attachmentURL,
        sendViaDefault,
        sendBulk
      })
      if (result.data.status === 'error') {
        throw new Error(result.data.errorMessage || 'error-send-email')
      }
    } catch (e) {
      throw e
    }
  }
  async _sendEmailWithPdf ({ fileName, base64, subject, sendViaDefault, displayName, emailToList, replyTo, sendBulk, body, emailSignature, translate }) {
    const { data: { filePath } } = await ServiceMediaUploads.uploadFile({ fileName, content: base64ToFileStream(base64) })

    return this._sendEmail({
      fromDisplayName: displayName,
      toEmails: emailToList,
      replyToEmail: replyTo,
      subject,
      html: [body, emailSignature, createPdfLink({ href: filePath, text: translate('download') })].filter(Boolean).join(''),
      sendViaDefault,
      sendBulk,
      attachmentURL: filePath
    })
  }
  async send ({ subject, sendViaDefault, displayName, emailToList, replyTo, sendBulk, body, emailSignature }) {
    return this._sendEmail({
      fromDisplayName: displayName,
      toEmails: emailToList,
      replyToEmail: replyTo,
      subject: subject,
      html: [body, emailSignature].filter(Boolean).join(''),
      sendViaDefault: sendViaDefault,
      sendBulk: sendBulk
    })
  }
  async sendQi ({ id, logoKey, translate, ...rest }) {
    const { data: pdfBase64 } = await ServicePdf.generateQi({ id, logoKey, translate })
    const fileName = `QI_${toDate(new Date(), 'YYYY-MM-DD')}.pdf`
    await this._sendEmailWithPdf({ fileName, base64: pdfBase64, translate, ...rest })
  }
  async sendPo ({ id, logoKey, baxpo, salesOrderID, translate, ...rest }) {
    const { data: pdfBase64 } = await ServicePdf.generatePo({ id, logoKey, translate, salesOrderID })
    const fileName = `PO_${baxpo}_${toDate(new Date(), 'YYYY-MM-DD')}.pdf`
    await this._sendEmailWithPdf({ fileName, base64: pdfBase64, translate, ...rest })
  }
  async sendWo ({ id, logoKey, baxpo, salesOrderID, translate, ...rest }) {
    const { data: pdfBase64 } = await ServicePdf.generateWo({ id, logoKey, translate, salesOrderID })
    const fileName = `PO_${baxpo}_${toDate(new Date(), 'YYYY-MM-DD')}.pdf`
    await this._sendEmailWithPdf({ fileName, base64: pdfBase64, translate, ...rest })
  }
  async sendInvoice ({ id, logoKey, invoiceTypeID, invoiceNumber, translate, ...rest }) {
    const { data: pdfBase64 } = await ServicePdf.generateInvoice({ id, logoKey, translate, invoiceTypeID })
    const fileName = `INVOICE_${invoiceNumber}.pdf`
    await this._sendEmailWithPdf({ fileName, base64: pdfBase64, translate, ...rest })
  }
  async sendTd ({ id, logoKey, isSendPdf, translate, ...rest }) {
    if (isSendPdf) {
      const { data: pdfBase64 } = await ServicePdf.generateTd({ id, logoKey, translate })
      const fileName = `TD_${toDate(new Date(), 'YYYY-MM-DD')}.pdf`
      await this._sendEmailWithPdf({ fileName, base64: pdfBase64, translate, ...rest })
    } else {
      await this.send(rest)
    }
  }
  async sendExchangeAgreement ({ id, logoKey, po, translate, ...rest }) {
    const { data: pdfBase64 } = await ServicePdf.generateExchangeAgreement({ id, logoKey, translate })
    const fileName = `EXCH_AGREEMENT_${po}_${toDate(new Date(), 'YYYY-MM-DD')}.pdf`
    await this._sendEmailWithPdf({ fileName, base64: pdfBase64, translate, ...rest })
  }
  async sendOrderAcknowledgment ({ id, logoKey, translate, ...rest }) {
    const { data: pdfBase64 } = await ServicePdf.generateOrderAcknowledgment({ id, logoKey, translate })
    const fileName = `ORDER_ACKNOWLEDGMENT_${toDate(new Date(), 'YYYY-MM-DD')}.pdf`
    await this._sendEmailWithPdf({ fileName, base64: pdfBase64, translate, ...rest })
  }
  async sendQuoteMultiParts ({ id, logoKey, partIDs, translate, ...rest }) {
    const { data: pdfBase64 } = await ServicePdf.generateQuoteMultiParts({ id, partIDs, logoKey, translate })
    const fileName = `BEL_AIR_EXPRESS_QUOTE_${toDate(new Date(), 'YYYY-MM-DD')}.pdf`
    await this._sendEmailWithPdf({ fileName, base64: pdfBase64, translate, ...rest })
  }
}

export const ServiceEmailMessages = new ModuleService()
